export enum InvoiceMessages {
  activeText = "global.activeText"
}

export interface TranslationInvoiceMessages {
  [InvoiceMessages.activeText]: string;
}
